<template>
  <v-container id="mainContent" fluid fill-height pa-0 class="grey lighten-1">
    <main-header />
    <main-content />
  </v-container>
</template>

<script>

import MainHeader from './MainHeader'
import MainContent from './MainContent'

export default {
  components: {
    'main-header': MainHeader,
    'main-content': MainContent
  }
}
</script>

<style scoped>
  #mainContent { /* Fill-height centra los items verticalmente */
    align-items: unset !important
  }
</style>
